import { ITheme } from '@/interface/ITheme';
import { useMemo } from 'react';

const useDarkTheme = (theme: ITheme): boolean => {
    return useMemo(() => theme === 'dark', [theme]);
};

export default useDarkTheme;
